const React = require('react');
const Toastr = require('toastr');
import Avatar from '@material-ui/core/Avatar';
import TextField from '@material-ui/core/TextField';
import { Button } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles } from '@material-ui/core/styles';

export class URLField extends React.Component{
   constructor(props) {
      super(props);
      this.state={
         isInErrorState: false,
         inputText: '',
      }
   }

   onChange(event){
      this.props.onChange(event,this.props.dataField);
      this.setState({inputText: event.target.value})
   }

   render() {
      const isInErrorState = this.props.checkForValidationErrors && this.state.inputText.trim() === '';
      return(
         <TextField
            error={this.props.error}
            id={this.props.idInput}
            name={this.props.idInput}
            type='text'
            className={'form__input url-creation-field ' + (isInErrorState ? 'validation-error' : '')}
            onChange={(event) => this.onChange(event)}
            value={this.props.url || ''}
            placeholder={this.props.placeholder}
            maxLength={this.props.maxLength || 1000}
            inputProps={{maxLength: this.props.maxLength || 1000}}
            label={this.props.label}
            variant='outlined'
         />
      );
   }
}

export class OneLineTextField extends React.Component{
   constructor(props) {
      super(props);
      this.state={
         inputText: '',
      }
   }

   onChange(event){
      this.props.onChange(event,this.props.dataField);
      this.setState({inputText: event.target.value})
   }

   render() {
      let { data } = this.props;
      if (data == null) data = ''; 
      const isInErrorState = this.props.checkForValidationErrors && this.state.inputText.trim() === '';
      return (
         <>
            <TextField
               error={this.props.error}
               id={this.props.idInput}
               type='text'
               onChange={(event) => this.onChange(event)}
               value={this.props.data || ''}
               className={'single-line-text-field' + (isInErrorState ? 'validation-error' : '')}
               placeholder={this.props.placeholder}
               maxLength={this.props.maxLength || 1000}
               inputProps={{maxLength: this.props.maxLength || 1000}}
               label={this.props.label}
               variant='outlined'
               margin={this.props.disableMargin?'none':'normal'}
               fullWidth
            />
         </>
      );
   }
}

export class IncubatorCommentTextField extends React.Component{
   constructor(props) {
      super(props);
      this.state={
         inputText: '',
         timer: 5000,
         isTyping: false
      }
      this.handleKeyPress = this.handleKeyPress.bind(this)
      this.handleKeyUp = this.handleKeyUp.bind(this)

   }
   handleKeyPress(e) {
      window.clearTimeout(this.state.timer);
      if(this.state.isTyping){
         window.clearTimeout(this.state.timer); 
      }else{
         this.props.typingFunction(true)
         this.setState({isTyping:true})
      }
   }
   handleKeyUp(e) {
      window.clearTimeout(this.state.timer); 
     this.setState({timer: window.setTimeout(() => { 
      this.props.typingFunction(false)
      this.setState({isTyping: false})
  }, 5000)})
   }

   render() {
      return(
         <TextField
            style={{ marginTop: '10px' }}
            placeholder="New Comment"
            className={'incubator-comment-text-field'}
            value={this.state.inputText}
            fullWidth
            multiline
            maxLength="1000"
            inputProps={{ maxLength: "1000" }}
            onKeyPress={this.handleKeyPress}
            onKeyUp={this.handleKeyUp}
            onChange={(e) => {
               this.setState({ inputText: e.target.value });
               }}
            InputProps={{
                  endAdornment: (
                     <Button size='small' color='primary' onClick={() => {this.setState({inputText:''}); this.props.submitFunction(this.state.inputText, this.props.idCardComment)}} variant='outlined'>Submit</Button>
                  ),
            }}
         />
      );
   }
}

export class MultiLineTextField extends React.Component{
   constructor(props) {
      super(props);
      this.state={
         inputText: '',
      }
   }

   onChange(event){
      this.props.onChange(event,this.props.dataField);
      this.setState({inputText: event.target.value})
   }

   onPaste(event){
      let pastedText = event.clipboardData.getData('text/plain');
      if( (this.props.data.length + pastedText.length) > (this.props.maxLength || 5000)){
         Toastr.options.positionClass = 'toast-bottom-full-width';
         Toastr.error('The pasted text is too long for the field and has been truncated.');
      }
   }

   render() {
      const isInErrorState = this.props.checkForValidationErrors && this.state.inputText.trim() === '';
      return(
         <div className={'multiline-text-field'}>
               <TextField
                  error={this.props.error}
                  id={this.props.idInput}
                  name={this.props.idInput}
                  multiline
                  variant="outlined"
                  rows='4'
                  onChange={(event) => this.onChange(event)}
                  value={this.props.data || ''}
                  className={'form__input multi-line-text-creation-field ' +  (isInErrorState ? 'validation-error' : '')}
                  placeholder={this.props.placeholder}
                  maxLength={this.props.maxLength || 5000}
                  inputProps={{maxLength: this.props.maxLength || 5000}}
                  onPaste={(e) => this.onPaste(e)}
                  onKeyPress={this.props.onKeyPress}
                  onKeyUp={this.props.onKeyUp}
                  onClick={this.props.onClick}
                  label={this.props.label}
                  margin='normal'
                  InputLabelProps={this.props.InputLabelProps}
               />
            <div className='input-characters-remaining'>
               Characters Remaining: {this.props.maxLength - this.props.data.length} {(this.props.helpLink)?<i><a href={this.props.helpLink}>Help</a></i>:""}
            </div>
         </div>
      );
   }
}

export class NumericTextField extends React.Component{
   constructor(props) {
      super(props);
   }

   onChange(event){
      this.props.onChange(event,this.props.dataField);
   }

   render() {
      return(
         <TextField
            id={this.props.idInput}
            name={this.props.idInput}
            placeholder={this.props.placeholder}
            label=""
            value={this.props.data || 0}
            onChange={(event) => this.onChange(event)}
            type="number"
            InputLabelProps={{shrink: true,}}
            margin="normal"
            className={'numeric-text-field'}
         />
      );
   }
}

export function userAvatar(userData){
      if(!userData) return <div className='avatar' />;
      if(userData.hasAvatar){
         return(
            <Avatar
               alt={`${userData.firstName} ${userData.lastName}`}
               src={window.globals.USER_UPLOADS_BASE_URL + '/' + userData.id + '/Avatar.png'}
               className='avatar'
            />
         );
      }
      else if(userData.lastName) {
         return(
            <Avatar
               alt={`${userData.firstName} ${userData.lastName}`}
               className='avatar'
            >
               {userData.lastName.substr(0, 1)}
            </Avatar>
         );
      }
}

const useAvatarStyles = makeStyles((theme) => ({
   small: {
     width: theme.spacing(5),
     height: theme.spacing(5),
   },
   medium: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   large: {
     width: theme.spacing(18),
     height: theme.spacing(18),
   },
 }));

export function UserAvatarV2(props) {
   let { userData } = props;
   const classes = useAvatarStyles();
   let size = props.size ? classes[props.size]: classes.small
   if(!userData) return(<Avatar src={''} className={size}/>)
   let userID = userData.id ? userData.id : userData.idUser;
      return (
         <Avatar
            src={userData.hasAvatar?`${window.globals.USER_UPLOADS_BASE_URL}/${userID}/Avatar.png`:''}
            className={size}
         />
      )
}

export function CircleIcon(props){
   let leftOffset = props.leftOffset || 0;
   let rightOffset = props.rightOffset || 0;
   return (
     <div style={{ paddingRight: '30px' }}>
       <span className="fa-layers fa-fw" style={{ width: '30px' }}>
         <FontAwesomeIcon size={'2x'} icon={['fas', "circle"]} color={props.color} transform="grow-6" />
         <FontAwesomeIcon size={'2x'} icon={props.icon} color='white' transform={`shrink-5 left-${leftOffset} right-${rightOffset}`} />
       </span>
     </div>
   );
 }